import React, { createContext, useContext } from 'react';
import type { AppConfig } from '@/config';

const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigProvider({ config, children }: { config: AppConfig; children: React.ReactNode }) {
  return <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>;
}

export function useAppConfig(): AppConfig {
  const ctx = useContext(AppConfigContext);
  return ctx ?? { googleClientId: '' };
}
